<template>
  <div class="page">
    <div class="nav">
      <span :class="selected1 == '库存明细' ? 'selected1' : ''" @click="navToggle('库存明细')">库存明细</span>
      <span>|</span>
      <span :class="selected1 == '库存金额分析' ? 'selected1' : ''" @click="navToggle('库存金额分析')">库存金额分析</span>
      <span>|</span>
      <span :class="selected1 == '库存周转率' ? 'selected1' : ''" @click="navToggle('库存周转率')">库存周转率</span>
    </div>

    <div v-show="selected1 == '库存明细'">
      <search-bar @search="searchReserveCost" name="" placeholder="输入物料编号、物料名称进行查找" ref="searchBar" />
      <div class="filter-bar">
        <span>
          {{ mode }}
          <i class="caret"></i>
          <select
            class="filter-item__select"
            v-model="mode"
            @change="searchStockDetail"
          >
            <option value="物料">物料</option>
            <option value="厂家/品牌">厂家/品牌</option>
          </select>
        </span>
      </div>
      <div class="weui-cells" style="margin-bottom: 50px;">
        <router-link class="weui-cell weui-cell_access" v-for="(item, index) in list1" :key="index"
          :to="{ name: 'StockReportDetail', params: { item } }">
          <div class="weui-cell__bd">
            <p v-if="mode == '物料'">{{ item.pr_detail }}</p>
            <p v-else>{{ item.pr_brand }}</p>
            <p v-if="mode == '物料'" class="list-item-muted">{{ item.pr_code }}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{ item.po_onhand }} {{ item.pr_unit }}</p>
            <div class="list-item-muted" v-if="!isFieldHidden('items.po_amount')">
              ￥<span v-format="'#,##0.00'" >{{ item.po_amount }}</span>
            </div>
          </div>
        </router-link>
      </div>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{ list1.length }}单</label>
        <div class="list-footer__value">
          ￥<em v-format="'#,##0.'" v-if="calculate">{{ calculate.po_amount }}</em>
        </div>
       
      </div>
    </div>

    <year-filter-bar @change="onYearChange"  v-if="selected1 != '库存明细'"/>

    <div class="canvas-box"  v-if="selected1 != '库存明细'">
      <canvas id="myChart" class="myChart2"></canvas>
    </div>
    <div v-show="selected1 == '库存金额分析'" style="margin-bottom: 48px">
      <div class="canvas-box" v-if="querytype2 == 'wareprodtype'">
        <canvas id="pieChart" class="pieChart"></canvas>
      </div>

      <div class="weui-cells" v-if="selected2 == '物料'">
        <product-field :label="'物料名称'" v-model="pr_detail" @select="selectPrDetail"></product-field>
      </div>

      <div class="list-box">
        <div class="list-box-nav">
          <span :class="selected2 == '仓库' ? 'selected2' : ''" @click="toggle2('仓库', 'warehouse')">仓库</span>
          <div :class="selected2 == '仓库类型' ? 'selected2' : ''" @click="toggle2('仓库类型', 'wareprodtype')">
            仓库类型
          </div>
          <span :class="selected2 == '物料' ? 'selected2' : ''" @click="toggle2('物料', 'prod')">物料</span>
        </div>
        <month-filter-bar @change="onMonthChange" />
        <div class="weui-cells">
          <div class="weui-cell weui-cell_access" v-for="(item, index) in list2" :key="index"
            @click="onChangeChart(item, 'onhand')">
            <div class="weui-cell__bd">
              <p>{{ item.text }}</p>
            </div>
            <div class="weui-cell__ft">
              <p v-if="querytype2 != 'prod'">{{ item.wh_text }}</p>
              <p v-else>{{ item.pr_detail }}</p>
              <p class="list-item-muted" v-format="'#,##0.'">
                {{ item["onhand" + month] }}
              </p>
            </div>
          </div>
        </div>
        <div class="list-footer">
          <label class="list-footer__label">{{ month }}月汇总</label>
          <em class="list-footer__value" v-format="'#,##0.'">{{
        getMonthTotal()
      }}</em>
        </div>
      </div>
    </div>

    <div v-show="selected1 == '库存周转率'">
      <!-- <year-filter-bar @change="onYearChange" />

      <div class="canvas-box">
        <canvas id="myChart3" class="myChart3"></canvas>
      </div> -->

      <div class="list-box">
        <div class="list-box-nav">
          <span :class="selected3 == '总物料' ? 'selected3' : ''" @click="toggle3('总物料', 'all')">总物料</span>
          <div :class="selected3 == '单个物料' ? 'selected3' : ''" @click="toggle3('单个物料', 'prod')">
            单个物料
          </div>
          <span :class="selected3 == '单个仓库' ? 'selected3' : ''" @click="toggle3('单个仓库', 'warehouse')">单个仓库</span>
        </div>
        <div class="weui-cells">
          <div class="weui-cell weui-cell_access" v-for="(item, index) in list3" :key="index"
            @click="onChangeChart(item, 'ito')">
            <div class="weui-cell__bd">
              <p>{{ item.text }}</p>
            </div>
            <div class="weui-cell__ft">
              <p v-if="querytype3 != 'prod'">{{ item.wh_description }}</p>
              <p v-else>{{ item.pr_detail }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import YearFilterBar from "@/components/YearFilterBar.vue";
import MonthFilterBar from "@/components/MonthFilterBar.vue";
import ProductField from "@/components/field/ProductField.vue";
import listCustomization from "@/mixins/listCustomization.js";

// import F2 from '@antv/f2'
import F2 from "@antv/f2/lib/index";
import ScrollBar from "@antv/f2/lib/plugin/scroll-bar";
import "@antv/f2/lib/interaction/pan";

export default {
  components: {
    SearchBar,
    YearFilterBar,
    MonthFilterBar,
    ProductField,
  },
  mixins: [listCustomization],
  data() {
    return {
      params: {
        caller: 'ReserveCostReport',
        name: 'stock-stockdetail-stockdetail', 
      },
      list1: [], // 库存明细列表
      calculate: {},
      result2: {}, // 库存金额分析
      list2: [], // 库存金额分析底部列表的数据
      result3: {}, // 库存周转率
      list3: [], // 库存周转率底部列表的数据
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      querytype2: "warehouse",
      querytype3: "all",
      selected1: "库存明细",
      selected2: "仓库",
      selected3: "总物料",
      mode: "物料",
      forecastType: "按物料",
      pr_detail: "",
      pwm_prodid: null,
      chart: null,
    };
  },
  mounted() {
    this.searchReserveCost();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    searchStockDetail() {
      this.searchReserveCost();
    },
    searchReserveCost(keyword) {
      let me = this;

      let params = {
        mode: me.mode == "物料" ? "prod" : "brand",
        condition: [],
        calculateFields: JSON.stringify([
          { field: "po_onhand", operation: "sum" },
          { field: "po_amount", operation: "sum" },
        ]),
      };
      if (keyword) {
        params.condition.push({
          type: "condition",
          value: `(upper(pr_orispeccode) like '%${keyword}%' or upper(pr_code) like '%${keyword}%' or upper(pr_detail) like '%${keyword}%' or upper(pr_brand) like '%${keyword}%')`,
        });
      }
      params.condition = JSON.stringify(params.condition);

      me.$ajax({
        url: "/api/document/product/stockDetail",
        params,
      }).then(function (res) {
        if (res.success) {
          me.list1 = res.data.list.list;
          me.calculate = res.data.calculate;
          // me.initChart()
          // me.initlist2()
        }
      });
    },
    searchStockTrend() {
      let me = this;

      let params = {
        year: me.year,
        querytype: me.querytype2,
      };
      if (me.pwm_prodid) params.con = `pwm_prodid like '%${me.pwm_prodid}%'`;

      me.$ajax({
        url: "/api/storage/report/getStockTrend",
        params,
      }).then(function (res) {
        if (res.success) {
          me.result2 = res.data;
          me.initChart(me.deal(me.result2.monthitems));
          me.list2 = me.result2.details;

          if (me.querytype2 == "wareprodtype") me.initPieChart();
        }
      });
    },
    searchStockITO() {
      let me = this;

      me.$ajax({
        url: "/api/storage/report/getStockITO",
        params: {
          year: me.year,
          querytype: me.querytype3,
        },
      }).then(function (res) {
        if (res.success) {
          me.result3 = res.data;
          me.initChart(me.deal(me.result3.monthitems));
          me.list3 = me.result3.details;
        }
      });
    },
    onResize() {
      var chart = this.chart;
      if (chart) {
        this.chart = chart.destroy();
        this.initChart(
          this.deal(
            this.selected1 == "库存金额分析"
              ? this.result2.monthitems
              : this.result3.monthitems
          )
        );
      }
    },
    initChart(data) {
      var chart = this.chart;
      if (chart) {
        chart.changeData(data);
        return;
      }
      this.chart = chart = new F2.Chart({
        id: "myChart",
        width: window.innerWidth,
        height: Math.min(window.innerHeight * 0.6, 300),
        pixelRatio: window.devicePixelRatio,
        plugins: ScrollBar,
      });

      chart.source(data, {
        index: {
          type: "linear",
          tickInterval: 1,
          min: -1,
          max: window.innerWidth > window.innerHeight ? 12 : 6,
          formatter: (i) =>
            i > -1 && i < 12
              ? [
                "01月",
                "02月",
                "03月",
                "04月",
                "05月",
                "06月",
                "07月",
                "08月",
                "09月",
                "10月",
                "11月",
                "12月",
              ][i]
              : null,
        },
      });

      chart
        .interval()
        .position("index*value")
        .color("type", (val) => {
          if (val === "金额") {
            return "#2eadf5";
          }
        })
        .adjust({
          type: "dodge",
          marginRatio: 0.05, // 设置分组间柱子的间距
        });
      if (window.innerWidth < window.innerHeight) {
        // 定义进度条
        chart.scrollBar({
          mode: "x",
          xStyle: {
            backgroundColor: "#e8e8e8",
            fillerColor: "#808080",
            offsetY: -2,
          },
        });
      }

      chart.interaction("pan");
      chart.render();
    },
    initPieChart() {
      let data = this.list2;

      data.forEach((item) => {
        item.onhand = 0;
        for (let i = 0; i < 12; i++) {
          item.onhand += item["onhand" + (i + 1)] || 0;
        }
      });

      let el = this.$el.querySelector(".pieChart");
      el.style.width = "100%";
      el.style.height = "300px";

      const chartPie = new F2.Chart({
        id: "pieChart",
        pixelRatio: window.devicePixelRatio,
      });

      chartPie.source(data);
      chartPie.coord("polar", {
        transposed: true,
        innerRadius: 0.4,
        radius: 0.75,
      });
      chartPie.axis(false);
      chartPie.legend({
        position: "bottom",
        align: "center",
      });
      chartPie
        .interval()
        .position("querytype*onhand")
        .color("text", [
          "#1890FF",
          "#2FC25B",
          "#FACC14",
          "#3436C7",
          "#223273",
          "#13C2C2",
          "#F04864",
          "#8543E0",
        ])
        .adjust("stack");
      chartPie.render();
    },
    onChangeChart(item, key) {

      const textArr = [
        "01月",
        "02月",
        "03月",
        "04月",
        "05月",
        "06月",
        "07月",
        "08月",
        "09月",
        "10月",
        "11月",
        "12月",
      ];

      let arr = [
        { index: -1, type: item.text, value: 0 },
        { index: 12, type: item.text, value: 0 },
      ];
      for (let i = 0; i < 12; i++) {
        arr.push({
          index: i,
          text: textArr[i],
          type: item.text,
          value: item[key + (i + 1)] || 0,
        });
      }
      this.initChart(arr);
    },
    navToggle(val) {
      this.selected1 = val;

      if (val == "库存金额分析") {
        this.searchStockTrend();
      } else if (val == "库存周转率") {
        this.searchStockITO();
      }
    },
    toggle2(val, querytype) {
      this.selected2 = val;
      this.querytype2 = querytype;
      this.searchStockTrend();
    },
    toggle3(val, querytype) {
      this.selected3 = val;
      this.querytype3 = querytype;
      this.searchStockITO();
    },
    onYearChange(year) {
      this.year = year;
      if (this.selected1 == "库存金额分析") {
        this.searchStockTrend();
      } else if (this.selected1 == "库存周转率") {
        this.searchStockITO();
      }
    },
    onMonthChange(month) {
      this.month = month;
    },
    getMonthTotal() {
      let sum = 0,
        month = this.month;
      this.list2.forEach((item) => {
        sum += item["onhand" + month] || 0;
      });

      return sum;
    },
    selectPrDetail(item) {
      this.pwm_prodid = item.id;
      this.searchStockTrend();
    },
    deal(data) {
      const textArr = [
        "01月",
        "02月",
        "03月",
        "04月",
        "05月",
        "06月",
        "07月",
        "08月",
        "09月",
        "10月",
        "11月",
        "12月",
      ];
      let arr = [
        { index: -1, type: "金额", value: 0 },
        { index: 12, type: "金额", value: 0 },
      ];

      for (let i = 0; i < 12; i++) {
        arr.push({
          text: textArr[i],
          type: "金额",
          index: i,
          value: Number(data[i]?.amount.toFixed(2)) || 0,
        });
      }

      return arr;
    },
  },
};
</script>

<style scoped>
.nav {
  padding: 10px 20px;
  display: flex;
  justify-content: space-around;
  background: var(--weui-BG);
}

.nav .selected1 {
  color: #38559f;
}

.canvas-box {
  /* width: 100%;
  height: 100%; */
  overflow-x: scroll;
  background: var(--weui-BG);
}

.list-box {
  margin-top: 5px;
  background: var(--weui-BG);
}

.list-box-nav {
  width: 100%;
  padding: 10px 10px 0;
  box-sizing: border-box;
  font-size: 13px;
  color: var(--weui-FG);
  display: flex;
  justify-content: space-around;
}

.selected2 {
  font-weight: 600;
  border-bottom: 2px solid var(--weui-FG);
}

.selected3 {
  font-weight: 600;
  border-bottom: 2px solid var(--weui-FG);
}

.list-box-content {
  overflow-y: scroll;
}
.filter-bar {
  width: 100%;
  background: var(--weui-BG-2);
  box-sizing: border-box;
  text-align: center;
  font-size: 13px;
  padding: 11px 0 9px 0;
  color: #9b9b9b;
  margin-bottom: 1px;
  display: flex;
}
.filter-bar span {
  margin: 0 auto;
  flex: 1;
  position: relative;
}
.filter-item__select {
  position: absolute;
  margin: 0;
  padding: 0;
  border: 0;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.filter-item__select option {
  color: var(--weui-FG-0);
  background: var(--weui-BG-2);
}

@media screen and (min-width: 500px) {
  .nav {
    display: none;
  }

  .filter-bar {
    padding: 6px 0 2px 0;
  }
}
</style>